import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appMarketRecommenderRequest = {};
var _appMarketRecommenderResponse = { webSolutions: '_webSolution' };
var _company = { averageRating: 'DOUBLE', webSolutions: '_webSolutionBase' };
var _getRandomRecommendationsRequest = {};
var _getRandomRecommendationsResponse = { webSolutions: '_webSolution' };
var _getRecommendedWebSolutionsRequest = {};
var _getRecommendedWebSolutionsResponse = { webSolutions: '_webSolution' };
var _getWebSolutionInAllLanguagesRequest = {};
var _getWebSolutionInAllLanguagesResponse = { webSolutions: '_webSolution' };
var _getWebSolutionsBaseResponse = { webSolutionsBase: '_webSolutionBase' };
var _getWebSolutionsByTagsRequest = {};
var _getWebSolutionsByTagsResponse = {
    tagsAndSubCategories: '_tagAndSubCats',
    webSolutions: '_webSolution',
};
var _getWebSolutionsRequest = {};
var _getWebSolutionsResponse = { webSolutions: '_webSolution' };
var _meteredBilling = {
    monthlyBaseFee: 'DOUBLE',
    additionalCharges: 'google.protobuf.DoubleValue',
};
var _plan = {
    monthlyPrice: 'DOUBLE',
    yearlyPrice: 'DOUBLE',
    oneTimePrice: 'DOUBLE',
    meteredBilling: '_meteredBilling',
};
var _pricing = {
    lowestMonthlyPrice: 'google.protobuf.DoubleValue',
    lowestMonthlyPriceWithTax: 'google.protobuf.FloatValue',
    plans: '_plan',
};
var _rankAppsByModelRequest = {};
var _rankAppsByModelResponse = { webSolutions: '_webSolution' };
var _tag = { dateCreated: 'google.protobuf.Timestamp' };
var _tagAndSubCats = { tag: '_tag' };
var _webSolution = { baseInfo: '_webSolutionBase', company: '_company' };
var _webSolutionBase = {
    reviewStars: 'google.protobuf.DoubleValue',
    pricing: '_pricing',
};
function resolveComWixpressDevcenterMarketApiWebSolutionsUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/marketplace-api',
                destPath: '/api',
            },
            {
                srcPath: '/marketplace',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/marketplace-api',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function get(payload) {
    var _a = serializer(_getWebSolutionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWebSolutionsResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.get',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/{idsOrSlugs}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
export function getWebSolutionsBase(payload) {
    var _a = serializer(_getWebSolutionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWebSolutionsBaseResponse, {
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getWebSolutionsBase(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.getWebSolutionsBase',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions-base/{idsOrSlugs}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWebSolutionsBase.fromReq = fromReq;
    __getWebSolutionsBase.__isAmbassador = true;
    return __getWebSolutionsBase;
}
export function getWebSolutionsByTags(payload) {
    var _a = serializer(_getWebSolutionsByTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWebSolutionsByTagsResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _tag: _tag,
        _tagAndSubCats: _tagAndSubCats,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getWebSolutionsByTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.getWebSolutionsByTags',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/tags/{tagsSlug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWebSolutionsByTags.fromReq = fromReq;
    __getWebSolutionsByTags.__isAmbassador = true;
    return __getWebSolutionsByTags;
}
export function getRecommendedWebSolutions(payload) {
    var _a = serializer(_getRecommendedWebSolutionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRecommendedWebSolutionsResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getRecommendedWebSolutions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.getRecommendedWebSolutions',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/recommended',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRecommendedWebSolutions.fromReq = fromReq;
    __getRecommendedWebSolutions.__isAmbassador = true;
    return __getRecommendedWebSolutions;
}
export function getRandomRecommendations(payload) {
    var _a = serializer(_getRandomRecommendationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRandomRecommendationsResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getRandomRecommendations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.getRandomRecommendations',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/random-recommendations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRandomRecommendations.fromReq = fromReq;
    __getRandomRecommendations.__isAmbassador = true;
    return __getRandomRecommendations;
}
export function appMarketRecommender(payload) {
    var _a = serializer(_appMarketRecommenderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_appMarketRecommenderResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __appMarketRecommender(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.appMarketRecommender',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/app-market-recommender',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __appMarketRecommender.fromReq = fromReq;
    __appMarketRecommender.__isAmbassador = true;
    return __appMarketRecommender;
}
export function rankAppsByModel(payload) {
    var _a = serializer(_rankAppsByModelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rankAppsByModelResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __rankAppsByModel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.rankAppsByModel',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/api/v1/web-solutions/rank-apps-by-model',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rankAppsByModel.fromReq = fromReq;
    __rankAppsByModel.__isAmbassador = true;
    return __rankAppsByModel;
}
export function getWebSolutionInAllLanguages(payload) {
    var _a = serializer(_getWebSolutionInAllLanguagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWebSolutionInAllLanguagesResponse, {
        _company: _company,
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolution: _webSolution,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getWebSolutionInAllLanguages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.marketplace.v1.web_solution',
            method: 'GET',
            methodFqn: 'com.wixpress.devcenter.market.api.WebSolutions.GetWebSolutionInAllLanguages',
            url: resolveComWixpressDevcenterMarketApiWebSolutionsUrl({
                protoPath: '/v1/web-solution-in-languages',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWebSolutionInAllLanguages.fromReq = fromReq;
    __getWebSolutionInAllLanguages.__isAmbassador = true;
    return __getWebSolutionInAllLanguages;
}
//# sourceMappingURL=http.impl.js.map